export default __webpack_public_path__ + "static/media/gear.0b4eb6fe.svg";